// Etichette + anteprima degli "Stili" (design preset, task #38) per la Console.
// ⚠️ Gli ID e i COLORI di `preview` DEVONO combaciare con la fonte canonica
// templates/restaurant/site/src/config/styles.ts (e con DESIGN_STYLE_IDS in
// apps/api/src/routes/admin.ts). `pnpm check:styles` lo verifica come 5° mirror:
// se qui un colore divergesse da styles.ts, la CI rompe la build (niente drift
// silenzioso). `preview` serve SOLO a dipingere le mini-card della galleria di
// scelta stile — l'anteprima fedele resta il `/preview` dal vivo.

/** Colori + font usati per disegnare la miniatura di uno Stile nella galleria. */
export interface StylePreview {
  bg: string; // fondo pagina
  primary: string; // colore brand (testata)
  onPrimary: string; // testo su primary
  accent: string; // accento (occhielli/bottoni)
  onAccent: string; // testo su accent
  text: string; // testo sul fondo
  font: string; // famiglia del titolo (display)
}

export const DESIGN_STYLES: { id: string; label: string; suited: string; preview: StylePreview }[] = [
  { id: 'classico', label: 'Classico', suited: 'Trattorie · fine dining',
    preview: { bg: '#FBF7EF', primary: '#2F3D2E', onPrimary: '#F7F2E7', accent: '#B0833C', onAccent: '#2A2014', text: '#26241D', font: "'Cormorant Garamond', serif" } },
  { id: 'editoriale', label: 'Editoriale', suited: 'Eleganti · enoteche',
    preview: { bg: '#FBFAF4', primary: '#262320', onPrimary: '#F5F1EA', accent: '#8C2F39', onAccent: '#F7EFE2', text: '#232019', font: "'Playfair Display', serif" } },
  { id: 'contemporaneo', label: 'Contemporaneo', suited: 'Pizzerie · street food',
    preview: { bg: '#FAFAF8', primary: '#1E1E1B', onPrimary: '#FAFAF7', accent: '#D23B2E', onAccent: '#FFFFFF', text: '#201F1C', font: "'Archivo', sans-serif" } },
  { id: 'artigianale', label: 'Artigianale', suited: 'Osterie · forni',
    preview: { bg: '#FBF7EF', primary: '#3A3026', onPrimary: '#F6EFE3', accent: '#C0613A', onAccent: '#2A1B12', text: '#26241D', font: "'Fraunces', serif" } },
  { id: 'minimal', label: 'Minimal', suited: 'Caffè · bistrot',
    preview: { bg: '#FAFAF8', primary: '#232320', onPrimary: '#FAFAF8', accent: '#7E8B6B', onAccent: '#1B1F16', text: '#201F1C', font: "'Hanken Grotesk', sans-serif" } },
  { id: 'mediterraneo', label: 'Mediterraneo', suited: 'Pesce · mare',
    preview: { bg: '#FBFAF4', primary: '#234E58', onPrimary: '#F2F7F6', accent: '#2E8090', onAccent: '#F2F7F6', text: '#232019', font: "'Newsreader', serif" } },
  { id: 'artdeco', label: 'Art Déco', suited: 'Cocktail bar · lounge',
    preview: { bg: '#F6F3EC', primary: '#16140F', onPrimary: '#E9D7A8', accent: '#C9A24B', onAccent: '#16140F', text: '#1E1C16', font: "'Poiret One', sans-serif" } },
  { id: 'robusto', label: 'Robusto', suited: 'Steakhouse · birrerie',
    preview: { bg: '#FBF7EF', primary: '#2A211B', onPrimary: '#F0E6D8', accent: '#9C5B3B', onAccent: '#F0E6D8', text: '#26241D', font: "'Zilla Slab', serif" } },
  { id: 'giocoso', label: 'Giocoso', suited: 'Gelaterie · pasticcerie',
    preview: { bg: '#FFFDF8', primary: '#2B2622', onPrimary: '#FFFDF8', accent: '#E06A9C', onAccent: '#FFFFFF', text: '#2B2622', font: "'Fredoka', sans-serif" } },
  { id: 'notte', label: 'Notte', suited: 'Brand forti · logo proprio · scuro',
    preview: { bg: '#1A1816', primary: '#8E2F22', onPrimary: '#F6EAE2', accent: '#C9A24B', onAccent: '#1A1816', text: '#F2EBE2', font: "'Cormorant Garamond', serif" } },
];

/** Base del sito che serve /preview (per l'anteprima dello Stile in Console). */
export const PREVIEW_BASE = 'https://trattoria.rismastudio.it';
